import { render, staticRenderFns } from "./FeedBackComentarioDepoimento.vue?vue&type=template&id=69a57324&scoped=true"
import script from "./FeedBackComentarioDepoimento.vue?vue&type=script&lang=js"
export * from "./FeedBackComentarioDepoimento.vue?vue&type=script&lang=js"
import style0 from "./FeedBackComentarioDepoimento.vue?vue&type=style&index=0&id=69a57324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a57324",
  null
  
)

export default component.exports